"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAxisNameConfiguration = void 0;
var sdk_ui_1 = require("@gooddata/sdk-ui");
var common_1 = require("../_util/common");
var axisLabel_1 = require("../../constants/axisLabel");
var axisNameConfigGetter = function (chartOptions) { return function (axisNamePrefix) {
    var _a;
    return ((_a = chartOptions === null || chartOptions === void 0 ? void 0 : chartOptions[axisNamePrefix + "Axes"]) !== null && _a !== void 0 ? _a : []).map(function (axis) {
        if (!axis) {
            return {};
        }
        return {
            title: getHighchartsAxisTitleConfiguration(chartOptions, axis, axisNamePrefix),
        };
    });
}; };
function getHighchartsAxisTitleConfiguration(chartOptions, axis, axisNamePrefix) {
    var _a, _b, _c;
    var isYAxis = axisNamePrefix === "y";
    var opposite = (_a = axis === null || axis === void 0 ? void 0 : axis.opposite) !== null && _a !== void 0 ? _a : false;
    var axisPropsKey = opposite ? "secondary_" + axisNamePrefix + "AxisProps" : axisNamePrefix + "AxisProps";
    var axisNameConfig = (_c = (_b = chartOptions === null || chartOptions === void 0 ? void 0 : chartOptions[axisPropsKey]) === null || _b === void 0 ? void 0 : _b.name) !== null && _c !== void 0 ? _c : {};
    var title = {};
    if (axisNameConfig.position) {
        title.align = axisNameConfig.position; // low | middle | high
    }
    // config.visible should be true/undefined by default
    if (axisNameConfig.visible === false) {
        title.text = "";
    }
    // opposite Y axis in combo, column and line chart
    // should be rotated the same way as its counterpart
    // and text alignment reversed from default
    if (opposite &&
        isYAxis &&
        common_1.isOneOfTypes(chartOptions.type, [
            sdk_ui_1.VisualizationTypes.COMBO,
            sdk_ui_1.VisualizationTypes.COMBO2,
            sdk_ui_1.VisualizationTypes.COLUMN,
            sdk_ui_1.VisualizationTypes.LINE,
        ])) {
        title.rotation = Number(axisLabel_1.ROTATE_NEGATIVE_90_DEGREES);
        if (title.align === "low") {
            title.textAlign = axisLabel_1.ALIGN_LEFT;
        }
        else if (title.align === "high") {
            title.textAlign = axisLabel_1.ALIGN_RIGHT;
        }
    }
    return title;
}
function getAxisNameConfiguration(chartOptions) {
    var configGetter = axisNameConfigGetter(chartOptions);
    return {
        xAxis: configGetter("x"),
        yAxis: configGetter("y"),
    };
}
exports.getAxisNameConfiguration = getAxisNameConfiguration;
//# sourceMappingURL=getAxisNameConfiguration.js.map